import React from "react";
import styled from "styled-components";

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  position: absolute;
  background: rgba(255, 255, 255, 0.7);
  z-index: 10;
`;

const Loader = () => (
  <LoaderWrapper>
    <div className="spinner-border text-primary" role="status">
      <span className="sr-only"> Loading...</span>
    </div>
  </LoaderWrapper>
);

export default Loader;
